"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.search");
var _PromotionTablePane = _interopRequireDefault(require("./PromotionTablePane.vue"));
var _PromotionConfigPane = _interopRequireDefault(require("./PromotionConfigPane.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'promotion',
  components: {
    PromotionTablePane: _PromotionTablePane.default,
    PromotionConfigPane: _PromotionConfigPane.default
  },
  data: function data() {
    return {
      activeName: 'table'
    };
  },
  created: function created() {},
  methods: {
    handleConfig: function handleConfig(promotionFnId) {
      this.activeName = 'config';
      this.promotionFnId = promotionFnId;
    },
    handleSuccess: function handleSuccess() {
      this.activeName = 'table';
      this.$refs.promotion_table_pane.search();
    }
  }
};